export default function StepProgress({ current, total, label, percent }) {
  const pct = percent ?? (total ? Math.round((current / total) * 100) : 0);

  return (
    <div>
      <div className="mb-1 flex justify-between text-xs text-gray-500">
        <span>
          {current}/{total}
          {label ? ` · ${label}` : ''}
        </span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-gray-100">
        <div className="h-1.5 rounded-full bg-primary transition-all" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
